var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c("path", {
          attrs: {
            transform: _vm.rotation,
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M7.0145 1.9288L8.42871 0.514587L15.9141 7.99996L8.42871 15.4853L7.0145 14.0711L12.0856 9H0V7H12.0857L7.0145 1.9288Z",
            fill: _vm.color
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }